module.exports = __webpack_public_path__ + "static/media/traning-course.501fd120.svg";